import React from 'react';

export default function TermsOfService() {
    const lastUpdated = "August 21, 2026";
    const appName = "blvd.ltd";
    const contactEmail = "mail@blvd.ltd";

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'sans-serif', lineHeight: '1.6' }}>
            <h1>Terms of Service</h1>
            <hr/>
            <p><strong>Last Updated:</strong> {lastUpdated}</p>

            <section>
                <h2>1. Acceptance of Terms</h2>
                <p>
                    By accessing or using {appName}, you agree to be bound by these Terms of Service.
                    If you do not agree to these terms, please do not use the website.
                </p>
            </section>

            <section>
                <h2>2. Use of the Site</h2>
                <p>
                    You agree to use this site only for lawful purposes and in a way that does not infringe
                    the rights of, restrict, or inhibit anyone else's use and enjoyment of the website.
                </p>
            </section>

            <section>
                <h2>3. Intellectual Property</h2>
                <p>
                    All content, design, text, graphics, and code on {appName} are the property of {appName}
                    unless otherwise stated, and are protected by copyright and intellectual property laws.
                </p>
            </section>

            <section>
                <h2>4. Limitation of Liability</h2>
                <p>
                    {appName} is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties,
                    express or implied, and hereby disclaim all other warranties. We are not liable for any
                    damages arising out of your use of this application.
                </p>
            </section>

            <section>
                <h2>5. Changes to Terms</h2>
                <p>
                    We reserve the right to modify these terms at any time. Continued use of the site following
                    any changes constitutes acceptance of those changes.
                </p>
            </section>

            <section>
                <h2>6. Contact Us</h2>
                <p>
                    If you have questions about these Terms, contact us at: <strong>{contactEmail}</strong>
                </p>
            </section>
        </div>
    );
}